import { render, staticRenderFns } from "./APersonaEstado.vue?vue&type=template&id=568e4bfa"
import script from "./APersonaEstado.vue?vue&type=script&lang=js"
export * from "./APersonaEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports